// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"422c693d","777":"3e983bde","821":"9f6cebd4"}[chunkId] + ".chunk.js";
};